
import Vue from "vue";
export default Vue.extend({
	props: {
		maxWidth: [String, Number],
		grow: Boolean,
		shrink: Boolean
	},
	computed: {
		maxWidthValue():string | undefined {
			if (!this.maxWidth) {
				return undefined;
			}
			return this.maxWidth + "px";
		}
	}
});
